import React from 'react'
import { createTheme, ThemeProvider as MUIThemeProvider } from '@mui/material/styles'
import { fontSizes } from '../Components/Common/Typography/TypographyStyles'
import { brandColors, notificationColors } from '../Components/Common/Color/Color'
import { iconButtonStyles } from '../styles/iconButtonStyles'
import buttonStyles from '../styles/buttonStyles'
import { switchStyles } from '../styles/switchStyles'
import { dialogStyles } from '../styles/dialogStyles'
import { dialogTitleStyles } from '../styles/dialogTitleStyles'

// Step 1: Create a custom theme
export const theme = createTheme({
  typography: {
    allVariants: {
      fontFamily: '"Helvetica", "Arial", sans-serif',
      fontSize: fontSizes.size12, // Ensure fontSizes is defined in your Typography styles
    },
  },
  palette: {
    primary: {
      main: brandColors.purpleDeluge, // Main primary color
    },
    secondary: {
      main: brandColors.greenSanFelix, // Main secondary color
    },
    success: {
      main: brandColors.greenAccessible,
    },
    error: {
      main: notificationColors.red,
    },
    warning: {
      main: notificationColors.amber,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: buttonStyles,
    },
    MuiIconButton: {
      styleOverrides: iconButtonStyles,
    },
    MuiSwitch: {
      styleOverrides: switchStyles,
    },
    MuiDialog: {
      styleOverrides: dialogStyles,
    },
    MuiDialogTitle: {
      styleOverrides: dialogTitleStyles,
    },
  },
})

// Step 2: Create a custom ThemeProvider component
const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <MUIThemeProvider theme={theme}>{children}</MUIThemeProvider>
}

export default ThemeProvider
